import React from 'react'
import PropTypes from 'prop-types'
import PlanPageContent from '../PlanPageContent'
import StepPageNavigator from '../StepPageNavigator'

const PlaybookPlanView = ({
  activePanel,
  activeStep,
  goalsAreCompleted,
  goalsIsInDraft,
  implementationApproachIsCompleted,
  linkDropdownDisplayTitle,
  linkMenu,
  onDropdownLinkSelect,
  onOpenAllStaffModal,
  onOpenFamiliesModal,
  onOpenStepModal,
  onStepClick,
  purposeIsCompleted,
  purposeIsInDraft,
  showSummary,
}) => (
  <>
    <PlanPageContent
      activePanel={activePanel}
      activeStep={activeStep}
      goalsIsInDraft={goalsIsInDraft}
      linkDropdownDisplayTitle={linkDropdownDisplayTitle}
      linkMenu={linkMenu}
      onDropdownLinkSelect={onDropdownLinkSelect}
      onOpenAllStaffModal={onOpenAllStaffModal}
      onOpenFamiliesModal={onOpenFamiliesModal}
      onOpenStepModal={onOpenStepModal}
      purposeIsInDraft={purposeIsInDraft}
      showSummary={showSummary}
    />
    {!showSummary && (
      <StepPageNavigator
        activeStep={activeStep}
        goalsAreCompleted={goalsAreCompleted}
        implementationApproachIsCompleted={implementationApproachIsCompleted}
        onStepClick={onStepClick}
        purposeIsCompleted={purposeIsCompleted}
      />
    )}
  </>
)

PlaybookPlanView.propTypes = {
  activePanel: PropTypes.object,
  activeStep: PropTypes.number,
  goalsAreCompleted: PropTypes.bool,
  goalsIsInDraft: PropTypes.bool,
  implementationApproachIsCompleted: PropTypes.bool,
  linkDropdownDisplayTitle: PropTypes.string,
  linkMenu: PropTypes.array,
  onDropdownLinkSelect: PropTypes.func,
  onOpenAllStaffModal: PropTypes.func,
  onOpenFamiliesModal: PropTypes.func,
  onOpenStepModal: PropTypes.func,
  onStepClick: PropTypes.func,
  purposeIsCompleted: PropTypes.bool,
  purposeIsInDraft: PropTypes.bool,
  showSummary: PropTypes.bool,
}

export default PlaybookPlanView
